/* eslint-disable */
import React from 'react';
import { Icon } from '@iconify/react';
/*import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';
import fileTextOutline from '@iconify/icons-eva/file-text-outline';
import folderOutline from '@iconify/icons-eva/folder-outline';*/
import peopleFill from '@iconify/icons-eva/people-fill';
import briefcaseFill from '@iconify/icons-eva/briefcase-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
//import pieChartFill from '@iconify/icons-eva/pie-chart-fill'

const getIcon = (name: any) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
    // {
    //     title: 'dashboard',
    //     icon: getIcon(pieChartFill),
    //     path: '/dashboard',
    //     isProduction: true
    // },
    {
        title: 'invoices',
        icon: getIcon(fileTextFill),
        path: '/list/invoice',
        isProduction: true,
        showInRegister: false
    },
    // {
    //     title: 'pay',
    //     icon: getIcon(briefcaseFill),
    //     path: '/list/pay',
    //     isProduction: false,
    //     showInRegister: false
    // },
    {
        title: 'client',
        icon: getIcon(peopleFill),
        path: '/list/customers',
        isProduction: true,
        showInRegister: true
    },
    {
        title: 'product',
        icon: getIcon(briefcaseFill),
        path: '/list/product',
        isProduction: true,
        showInRegister: true
    },

    {
        title: 'pay',
        icon: getIcon(briefcaseFill),
        path: '/list/pay',
        isProduction: true,
        showInRegister: false
    },
    // {
    //     title: 'invoices',
    //     icon: getIcon(fileTextFill),
    //     path: '/create',
    //     isProduction: true,
    //     children: [
    //         {
    //             title: 'invoice_create',
    //             path: '/create/invoice'
    //         }
    //     ]
    // },

    // {
    //     title: 'product',
    //     icon: getIcon(briefcaseFill),
    //     path: '/product',
    //     isProduction: true,
    //     children: [
    //         {
    //             title: 'product_create',
    //             path: '/new/product'
    //         },
    //         {
    //             title: 'product_list',
    //             path: '/list/product'
    //         }
    //     ]
    // },
    /*{
        title: 'poc',
        icon: getIcon(folderOutline),
        path: '/poc',
        isProduction: false,
        children: [
            {
                title: 'simple_form',
                path: '/poc/simple/form'
            },
            {
                title: 'lw_form',
                path: '/poc/wizard'
            },
            {
                title: 'acc_forms',
                path: '/poc/simple/accordion'
            },
            {
                title: 'uploader',
                path: '/poc/simple/uploader'
            },
            {
                title: 'poc_customers_edit',
                path: '/poc/edit/customer'
            },
            {
                title: 'poc_products_edit',
                path: '/poc/edit/product'
            }
        ]
    },
    {
        title: 'not_found',
        icon: getIcon(alertTriangleFill),
        path: '/404',
        isProduction: false
    }*/
];

export default sidebarConfig;
